const masks = {
  phone: {
    mask: "+34(6|7)9{8}",
    greedy: false,
    placeholder: "",
    onBeforePaste: function (pastedValue) {
      var maxLength = 9
      if (pastedValue.startsWith("+34")) {
        var trimmedValue = pastedValue.slice(0, maxLength + 3)
        return trimmedValue
      }
      return ""
    },
  },
  personal_code: {
    mask: "99999999X",
    placeholder: "",
    definitions: {
      9: {
        validator: "[0-9]",
        cardinality: 1,
      },
      X: {
        validator: "[0-9A-Za-z]",
        casing: "upper",
      },
    },
  },
  bank_account_number: {
    mask: "ES9{22}",
    greedy: false,
    placeholder: "",
    onBeforePaste: function (pastedValue) {
      var maxLength = 22
      pastedValue = pastedValue.replace(/\s/g, '');
      if (pastedValue.startsWith("ES")) {
        var trimmedValue = pastedValue.slice(0, maxLength + 2)
        return trimmedValue
      }
      return ""
    },
  },
}

// jQuery("#LeadForm-phone").inputmask(masks.phone)

jQuery("#LeadForm-phone").on("focus input", function() {
  setInitialValue()

  if (!jQuery(this).val().startsWith('+34 ')) {
    jQuery(this).val('+34 ');
  }
})

function setInitialValue() {
  var leadPhone = jQuery('#LeadForm-phone');
  if (!leadPhone.val().trim()) {
    leadPhone.val('+34 ');
  }
}

jQuery("#LeadForm-phone").mask("+34 X00 000 000", {'translation': {
    X: {pattern: /[6|7]/}
  }
})

jQuery("#LeadForm-personal_code").inputmask(masks.personal_code)

jQuery("#LeadForm-bank_account_number").inputmask(masks.bank_account_number)
